import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const Field = ({ label, id, ...props }) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-sm font-semibold text-[#1B2A26]">{label}</Label>
    <Input id={id} className="h-14 rounded-xl text-base bg-[#FAF8F5] focus-visible:bg-white" {...props} />
  </div>
);

export const BigButton = ({ className = "", variant = "primary", ...props }) => {
  const styles = {
    primary: "bg-[#1E4D2B] text-white hover:bg-[#163A20]",
    earth: "bg-[#C86D51] text-white hover:bg-[#B05A40]",
    outline: "bg-white text-[#1B2A26] border-2 border-[#E2DDD3] hover:border-[#1E4D2B] hover:bg-[#E8F5E9]",
  };
  return (
    <button
      className={`h-14 w-full rounded-xl font-semibold text-base flex items-center justify-center gap-2 transition-[background-color,border-color,transform] active:scale-[0.98] disabled:opacity-60 ${styles[variant]} ${className}`}
      {...props}
    />
  );
};
